import { useState, useEffect, useCallback } from "react";
import { API, AUTH, fmtDate } from "../../adminUtils";

export default function WaiverReport() {
  const [waivers, setWaivers]         = useState([]);
  const [loading, setLoading]         = useState(false);
  const [emailTarget, setEmailTarget] = useState({});  // { email: overrideAddress }
  const [emailStatus, setEmailStatus] = useState({});  // { email: 'sending'|'sent'|'error' }

  const fetchWaivers = useCallback(async () => {
    setLoading(true);
    try {
      const res  = await fetch(`${API}/reports/waivers`, { headers: AUTH });
      const data = await res.json();
      setWaivers(Array.isArray(data) ? data : []);
    } catch {
      setWaivers([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchWaivers(); }, [fetchWaivers]);

  const handlePrint = (email) => {
    window.open(
      `${API}/waiver/pdf/${encodeURIComponent(email)}?token=admin123`,
      "_blank"
    );
  };

  const handleEmail = async (email) => {
    const recipient = emailTarget[email]?.trim() || email;
    setEmailStatus(s => ({ ...s, [email]: "sending" }));
    try {
      const res = await fetch(`${API}/waiver/send-pdf`, {
        method:  "POST",
        headers: AUTH,
        body: JSON.stringify({ email, recipientEmail: recipient }),
      });
      const next = res.ok ? "sent" : "error";
      setEmailStatus(s => ({ ...s, [email]: next }));
      setTimeout(() => setEmailStatus(s => { const n = { ...s }; delete n[email]; return n; }), 3000);
    } catch {
      setEmailStatus(s => ({ ...s, [email]: "error" }));
    }
  };

  if (loading) return <p className="adm-loading">Loading…</p>;

  return (
    <div>
      <div className="adm-report-summary-row">
        <div className="adm-summary-chip">
          <span className="adm-summary-val">{waivers.length}</span>
          <span className="adm-summary-lbl">Signed</span>
        </div>
        <div className="adm-summary-chip">
          <span className="adm-summary-val">{waivers.filter(w => !w.waiverPdfPath).length}</span>
          <span className="adm-summary-lbl">Missing PDF</span>
        </div>
      </div>

      {waivers.length === 0
        ? <p className="adm-empty">No signed waivers on record.</p>
        : (
          <div className="adm-table-wrap">
            <table className="adm-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Date Signed</th>
                  {/* <th>PDF</th> */}
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {waivers.map((w) => {
                  const st = emailStatus[w.email];
                  return (
                    <tr key={w.email}>
                      <td>{w.name || "—"}</td>
                      <td className="adm-email">{w.email}</td>
                     <td>{fmtDate(w.waiverSignedAt)}</td>
                      <td>
                        <div style={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}>
                          <input
                            type="email"
                            className="adm-input"
                            placeholder={w.email}
                            value={emailTarget[w.email] || ""}
                            onChange={e => setEmailTarget(t => ({ ...t, [w.email]: e.target.value }))}
                          />
                          <div style={{ display: "flex", gap: "0.4rem" }}>
                            {w.waiverPdfPath
                              ? <button className="adm-btn-ghost-sm" onClick={() => handlePrint(w.email)}>Print</button>
                              : <span className="adm-badge adm-badge--warn">No PDF</span>
                            }
                            <button
                              className="adm-btn-primary-sm"
                              onClick={() => handleEmail(w.email)}
                              disabled={!w.waiverPdfPath || st === "sending"}
                            >
                              {st === "sending" ? "Sending…"
                                : st === "sent"  ? "✓ Sent"
                                : st === "error" ? "Error"
                                : "Send"}
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )
      }
    </div>
  );
}